import { useEffect } from 'react';
import {
  SITE_URL,
  DEFAULT_TITLE,
  DEFAULT_DESCRIPTION,
  absoluteUrl,
} from './seo';

function setMetaBySelector(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    if (selector.includes('property=')) {
      el.setAttribute('property', selector.match(/property="([^"]+)"/)[1]);
    } else if (selector.includes('name=')) {
      el.setAttribute('name', selector.match(/name="([^"]+)"/)[1]);
    }
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setLinkRel(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function usePageMeta({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '/',
  image = '/og.jpg',
  noIndex = false,
} = {}) {
  useEffect(() => {
    const fullTitle = title
      ? (title.includes('LoreBites') ? title : `${title} · LoreBites`)
      : DEFAULT_TITLE;
    const url = absoluteUrl(path);
    const imageUrl = image.startsWith('http') ? image : absoluteUrl(image);

    document.title = fullTitle;

    setMetaBySelector('meta[name="description"]', 'content', description);
    setMetaBySelector('meta[property="og:title"]', 'content', fullTitle);
    setMetaBySelector('meta[property="og:description"]', 'content', description);
    setMetaBySelector('meta[property="og:url"]', 'content', url);
    setMetaBySelector('meta[property="og:image"]', 'content', imageUrl);
    setMetaBySelector('meta[property="og:type"]', 'content', 'website');
    setMetaBySelector('meta[property="og:site_name"]', 'content', 'LoreBites');
    setMetaBySelector('meta[name="twitter:card"]', 'content', 'summary_large_image');
    setMetaBySelector('meta[name="twitter:title"]', 'content', fullTitle);
    setMetaBySelector('meta[name="twitter:description"]', 'content', description);
    setMetaBySelector('meta[name="twitter:image"]', 'content', imageUrl);
    setLinkRel('canonical', url);

    if (noIndex) {
      setMetaBySelector('meta[name="robots"]', 'content', 'noindex, nofollow');
    } else {
      const robots = document.head.querySelector('meta[name="robots"]');
      if (robots) robots.setAttribute('content', 'index, follow');
    }
  }, [title, description, path, image, noIndex]);
}

export { SITE_URL, DEFAULT_TITLE, DEFAULT_DESCRIPTION };
